<script setup>
import LivrenteIndbetalingChart from '@/pages/kvartalsrapport/charts/LivrenteIndbetalingChart.vue';
import LivrenteNysalgChart from '@/pages/kvartalsrapport/charts/LivrenteNysalgChart.vue';
import LivrenteNysalgModTop5Chart from '@/pages/kvartalsrapport/charts/LivrenteNysalgModTop5Chart.vue';
import LivrenteBestandChart from '@/pages/kvartalsrapport/charts/LivrenteBestandChart.vue';
import { useKvartalsrapportStore } from '@/stores/kvartalsrapportStore.js';
import LetLoadIndicator from '@/letapps-vue/components/LetLoadIndicator.vue';
import LivrenteSalgPrUgeChart from '@/pages/kvartalsrapport/charts/LivrenteSalgPrUgeChart.vue';
import LivrenteSalgFordelingStykChart from '@/pages/kvartalsrapport/charts/LivrenteSalgFordelingStykChart.vue';
import LivrenteSalgFordelingBeloebChart from '@/pages/kvartalsrapport/charts/LivrenteSalgFordelingBeloebChart.vue';
import LtsAntalAftalerChart from './charts/LtsAntalAftalerChart.vue';
import LtsSalgFordelingStykChart from './charts/LtsSalgFordelingStykChart.vue';
import LtsSalgFordelingBeloebChart from './charts/LtsSalgFordelingBeloebChart.vue';
import LtsIndtjeningFordelingChart from './charts/LtsIndtjeningFordelingChart.vue';

defineProps({
  print: {
    type: Boolean,
    default: false,
  },
});

const store = useKvartalsrapportStore();
</script>

<template>
  <div class="titel">Letsikring til selvstændige</div>
  <div class="flex-container container" v-if="store.udvikling">
    <div class="flex-1">
      <div class="chart-titel">Hvor meget er der indbetalt i mio. kr.?</div>
      <LivrenteIndbetalingChart :print="print" :lts="true" />
      <div class="chart-titel">Hvor stort er nysalget i mio. kr.?</div>
      <LivrenteNysalgChart :print="print" :lts="true" />
      <div class="chart-titel">
        Hvordan er salget i mio. kr. pr. 100 medarbejdere – sammenlignet med top 5
      </div>
      <LivrenteNysalgModTop5Chart :print="print" :lts="true" />
    </div>
    <div class="flex-1">
      <div class="chart-titel">Hvor stor er bestanden i mio. kr.?</div>
      <LivrenteBestandChart :print="print" :lts="true" />
      <div class="chart-titel">Antal nye aftaler pr. måned</div>
      <LtsAntalAftalerChart :print="print" />
      <div class="chart-titel">Hvordan er salget sammenlignet med sidste års salg i mio. kr.?</div>
      <LivrenteSalgPrUgeChart :print="print" :lts="true" />
    </div>
    <div class="flex-1">
      <div class="chart-titel">Nysalg stk.</div>
      <LtsSalgFordelingStykChart :print="print" />
      <div class="chart-titel">Nysalg mio kr.</div>
      <LtsSalgFordelingBeloebChart :print="print" />
      <div class="chart-titel">Indtjening risiko og livrente</div>
      <LtsIndtjeningFordelingChart :print="print" />
    </div>
  </div>
  <div v-else>
    <LetLoadIndicator :visible="true" />
    <div>Henter udvikling...</div>
  </div>
</template>

<style scoped lang="scss">
@import '@/css//variables.letguide.scss';

.flex-1 {
  min-width: 250px;
}
</style>
